import { useEffect } from "react";

type SeoProps = {
  title: string;
  description?: string;
  keywords?: string;
  jsonLd?: Record<string, unknown>[];
};

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, keywords, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
    }
    if (keywords) upsertMeta("name", "keywords", keywords);

    // 清理旧的 json-ld，避免跨页残留
    document.head
      .querySelectorAll("script[data-readdy-jsonld]")
      .forEach((n) => n.remove());
    if (jsonLd && jsonLd.length) {
      jsonLd.forEach((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-readdy-jsonld", "true");
        s.textContent = JSON.stringify(obj);
        document.head.appendChild(s);
      });
    }
  }, [title, description, keywords, jsonLd]);

  return null;
}